export default __webpack_public_path__ + "static/media/gw.337bb6e5.png";